import actionTypes from 'constants/actionTypes';

import { IncentiveOfferType } from 'modules/incentivesMarket/types';
import { AddIncentiveOfferPageProvider } from '../pages/AddIncentiveOffer/context/AddIncentiveOfferPageContext';
import AddIncentiveOfferPage from '../pages/AddIncentiveOffer';

const AddSellIncentiveOfferPageContainer = () => (
  <AddIncentiveOfferPageProvider
    incentiveOfferType={IncentiveOfferType.SELL}
    actionType={actionTypes.ADD}
  >
    <AddIncentiveOfferPage />
  </AddIncentiveOfferPageProvider>
);

export default AddSellIncentiveOfferPageContainer;
